import * as yup from 'yup';
import axios from 'axios';

export const ChangePasswordPolicyFormValidation = yup.object().shape({
  requiredLength: yup.number().integer('').required('Devem ser números inteiros').positive('Devem ser números positivos'),
  requiredUniqueChars: yup.number().integer('').required('Devem ser números inteiros')
});